export const theme = {
  backgroundColor: '#fff',
  errorColor: '#e21313',
  formField: {
    borderRadius: '5px',
  },
  linkColor: '#32f',
  primaryColor: '#1e90ff',
};
